import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { filter, map } from 'rxjs';
import { authenticationActions, selectAuthentication } from '@redux/authentication.redux';

export const moduleGuard: CanActivateFn = (state) => {
  const store = inject(Store);
  const communityCode = '/' + (localStorage.getItem('community') ?? '/404');

  return store.select(selectAuthentication.selectRole).pipe(
    filter((role) => !!role), // Asegúrate de que ambos están cargados
    map((role) => {
      const isFamilyRoute = state.url.toString().startsWith('family');
      if (role === 'COMMUNITY_RESIDENT' && !isFamilyRoute) {
        return true;
      } else if (role === 'COMMUNITY_RELATIVE' && isFamilyRoute) {
        return true;
      }
      store.dispatch(authenticationActions.logout({ communityCode }));
      return false;
    }),
  );
};
